import axios from "axios";
import { showDialog, showNotify } from "vant";
import router from "@/router";
import store from "@/store";
export const $http = axios.create({
  baseURL: window.apiUrl,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
});

// 添加请求拦截器
$http.interceptors.request.use(
  function (config) {
    if (config.headers.LoadMsg) {
      store.commit("setLoading", {
        status: true,
        message: decodeURIComponent(config.headers.LoadMsg),
      });
    }
    if (config.params?.Params) {
      config.params.Params = JSON.stringify(config.params.Params);
    }

    config.headers.Authorization = localStorage.getItem("token");
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

let showLogin = false; //是否提示登录框

// 添加响应拦截器
$http.interceptors.response.use(
  function (response) {
    store.commit("setLoading", {
      status: false,
    });
    return response;
  },
  function (error) {
    store.commit("setLoading", {
      status: false,
    });
    //如果response为空的，接口服务未启动
    if (error.response === undefined) {
      showNotify({ type: "danger", message: "服务器异常，请求失败，Err01！" });
      return Promise.reject(-10);
    } else {
      //400一般错误，直接弹出提示框
      if (error.response.status === 400) {
        //如果是400错误，则监测该接口是否允许弹窗提示错误，如果允许则弹窗，不允许则返回400错误对象
        if (error.response.config.headers.ShowError) {
          showNotify({
            type: "danger",
            message: error.response.data.msg,
          });
        }
        return Promise.reject(error.response.data);
      }
      //401未授权
      else if (error.response.status == 401) {
        if (!showLogin) {
          showLogin = true;
          showDialog({
            title: "登录",
            message: "请重新登录！",
          }).then(() => {
            localStorage.removeItem("token");
            showLogin = false;
            router.go(0);
          });
          return Promise.reject("您的账号未授权~");
        }
      } else if (error.response.status == 404) {
        return Promise.reject("出错啦~");
      } else if (error.response.status == 500) {
        if (error.response.config.headers.ShowError) {
          showNotify({
            type: "danger",
            message: "服务器异常，请求失败，Err02！",
          });
        }
        return Promise.reject("出错啦~");
      } else {
        return Promise.reject("未知错误~");
      }
    }
  }
);

//加载动画及错误信息提示    1：表示显示加载动画，不提示错误信息   2：不显示加载动画，提示错误信息  3：表示即显示加载动画，又错误提示
export const buildHeaders = (type, loadMsg = "正在提交数据，请稍后……") => {
  let data = {};
  if (type === 1) {
    //表示显示加载动画，不提示错误信息
    data = {
      LoadMsg: encodeURIComponent(loadMsg),
    };
  } else if (type === 2) {
    //不显示加载动画，提示错误信息
    data = {
      ShowError: true,
    };
  } else if (type === 3) {
    //表示即显示加载动画，又错误提示
    data = {
      LoadMsg: encodeURIComponent(loadMsg),
      ShowError: true,
    };
  }
  return data;
};
